import { useTranslation } from "react-i18next";
import SimpleMap from "../common/SimpleMap";
import DeviceAlertTable from "../sites/site/device/AlertTable";
import { useEffect, useState } from "react";
import AlertService from "../../services/alert.service";
import { useParams } from "react-router-dom";
import JobsService from "../../services/job.service";
import SiteService from "../../services/site.service";
import { formatToShortCst } from "../../utils/formatToShortCst";
import { Alert } from "../../types/Alert";
import { Site } from "../../types/Site";
import { Job } from "../../types/Job";


export default function JobPage()  {
  const { t } = useTranslation();
  const { jobId } = useParams();
  const [alerts, setAlerts] = useState<Alert[]>([]); // update type parmeter when alert backend is defined
  const [job, setJob] = useState<Job | null>(null);
  const [site, setSite] = useState<Site | null>(null);

  const fetchJobById = async () => {
    if (jobId) {
      const jobResponse = await JobsService.getJobById(jobId);
      const data = await jobResponse.json();
      setJob(data);
      return data;
    }
    return null;
};
 
  const fetchAlertData = async (siteId: string) => {
      if (siteId) {
        const alertResponse = await AlertService.searchAlert({siteId});
        const data = await alertResponse.json();
        setAlerts(data);
      }
  };

  const fetchSiteData = async (siteId: string) => {
    const siteResponse = await SiteService.getSite(siteId);
    const siteData = await siteResponse.json();
    setSite(siteData);
  }

  useEffect(() => {
    fetchJobById().then(job => {
      fetchAlertData(job.siteId);
      fetchSiteData(job.siteId);
    });
  }, []);

  const prettyAddress = () => {
    if(site) {
      return `${site.address.address1}, ${site.address.locality}, ${site.address.region},  ${site.address.postalCode},  ${site.address.country}`;
    }
    return '';
  }

  return (
    <>
      <div className="pt-3 mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <h2 className="text-lg font-bold leading-6 text-gray-900">
              {t('jobs.job')}
            </h2>
        <div className="flex flex-row items-start justify-between pt-3">
          <div className="mr-6 w-64 h-64 flex-shrink-0">
            <SimpleMap coordinates={site?.location?.coordinates} className="rounded-md shadow-md" />
          </div>

          <div className="flex-grow">

            <div className="mt-6 grid grid-cols-6 gap-6">
              <div className="col-span-6 sm:col-span-6">
                <label
                  htmlFor="address"
                  className="block text-sm font-medium text-gray-700"
                >
                  {t('sites.address')}
                </label>
                <input
                  type="text"
                  value={prettyAddress()}
                  readOnly
                  className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                />
                </div>

                <div className="col-span-6 sm:col-span-2">
                  <label
                    htmlFor="state"
                    className="block text-sm font-medium text-gray-700"
                  >
                    {t('jobs.jobType')}
                  </label>
                  <input
                    type="text"
                    value={job?.jobType}
                    readOnly
                    className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                  />
                </div>
                <div className="col-span-6 sm:col-span-2">
                  <label
                    htmlFor="state"
                    className="block text-sm font-medium text-gray-700"
                  >
                    {t('jobs.status')}
                  </label>
                  <input
                    type="text"
                    value={job?.status}
                    readOnly
                    className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                  />
                </div>
                <div className="col-span-6 sm:col-span-2">
                  <label
                    htmlFor="state"
                    className="block text-sm font-medium text-gray-700"
                   >
                     {t('jobs.assignee')}
                  </label>
                  <input
                    type="text"
                    value={typeof job?.assignee === 'string' ? '-' : job?.assignee?.firstName + ' ' + job?.assignee?.lastName}
                    readOnly
                    className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                  />
                </div>
                <div className="col-span-6 sm:col-span-3">
                  <label
                    htmlFor="state"
                    className="block text-sm font-medium text-gray-700"
                  >
                    {t('jobs.createdAt')}
                  </label>
                  <input
                    type="text"
                    value={job?.createdAt ? formatToShortCst(job?.createdAt) : ""}
                    readOnly
                    className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                  />
                </div>
                <div className="col-span-6 sm:col-span-3">
                  <label
                    htmlFor="state"
                    className="block text-sm font-medium text-gray-700"
                  >
                    {t('jobs.endedAt')}
                  </label>
                  <input
                    type="text"
                    value={job?.endedAt ? formatToShortCst(job?.endedAt) : ""}
                    readOnly
                    className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                  />
                </div>
              </div>
            </div>
          </div>
          <DeviceAlertTable alertData={alerts.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())} />
        </div>
    </>
  );
}